import ImgContainer from "components/common/img";
import React from "react";
import { UncontrolledTooltip } from "reactstrap";
import { getFormattedContactNumber, hasPermission } from "utility/helpers";
import { CellText, StyledEditIcon, StyledTrashIcon } from "assets/js/Styles";
import styled from "styled-components";

const PhotoFrame = styled.div`
  width: 50px;
  height: 45px;
  border-radius: 50%;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const nationalAgencyColumns = ({ userImage, navigate, handleDeleteAction }) => {
  return [
    {
      name: "",
      selector: null,
      sortable: false,
      id: "highlight",
      width: "5px",
      cell: () => null,
    },
    {
      name: "",
      selector: ({ photo }) => photo,
      grow: 0,
      minWidth: "80px",
      sortable: false,
      style: { paddingTop: "0.5rem", paddingBottom: "0.5rem" },
      cell: ({ photo }) => (
        <PhotoFrame>
          <ImgContainer
            alt="cong-image"
            src={photo || userImage}
            width="50px"
          />
        </PhotoFrame>
      ),
    },
    {
      name: "Agency",
      selector: ({ NationalAgency }) => NationalAgency,
      identifier: "agency",
      grow: 2,
      sortable: true,
      cell: ({ NationalAgency }) => (
        <CellText>{NationalAgency?.agencyAcronym || ""}</CellText>
      ),
    },
    {
      name: "Name",
      selector: ({ name }) => name,
      identifier: "name",
      grow: 3,
      sortable: true,
      cell: ({ name }) => <CellText>{name}</CellText>,
    },
    {
      name: "Contact Info",
      selector: ({ contact }) => contact,
      identifier: "contact",
      grow: 2,
      sortable: true,
      cell: ({ contact }) => (
        <CellText>{getFormattedContactNumber(contact)}</CellText>
      ),
    },
    {
      name: "Designation",
      selector: ({ designation }) => designation,
      identifier: "designation",
      grow: 2,
      sortable: true,
      cell: ({ designation }) => <CellText>{designation}</CellText>,
    },
    {
      name: "Area",
      selector: ({ area }) => area,
      identifier: "area",
      grow: 2,
      sortable: true,
      cell: ({ area }) => <CellText>{area}</CellText>,
    },
    {
      name: "Action",
      selector: (row) => row?.id,
      sortable: false,
      width: "100px",
      style: { cursor: "pointer" },
      center: true,
      id: "action",
      cell: (row) => (
        <>
          {hasPermission("agency-update") && (
            <>
              <StyledEditIcon
                size={16}
                id={`edit-row--${row.id}`}
                onClick={() => {
                  navigate("/national/", {
                    state: { row },
                  });
                }}
              />
              <UncontrolledTooltip
                placement="auto"
                target={`edit-row--${row.id}`}
              >
                {"Edit"}
              </UncontrolledTooltip>
            </>
          )}

          {hasPermission("agency-delete") && (
            <>
              <StyledTrashIcon
                size={16}
                id={`delete-row--${row.id}`}
                onClick={() => handleDeleteAction(row)}
              />
              <UncontrolledTooltip
                placement="right"
                target={`delete-row--${row.id}`}
              >
                {"Delete"}
              </UncontrolledTooltip>
            </>
          )}
        </>
      ),
    },
  ];
};

export default nationalAgencyColumns;
